import { create } from "zustand";
import { CHECK_IS_FREE } from "../Utils/constant";
import { find, verifyPaiement } from "../services/service";

export const useVerifyPaiementStore = create((set) => ({
  loading: false,
  data: null,
  isFree: null,
  isloading: false,
  verification: async (ref) => {
    set({
      loading: true,
      data: null,
    });

    try {
      const verify = await verifyPaiement(ref);
      set({
        loading: false,
        data: verify.data,
      });
    } catch (error) {
      set({
        loading: false,
        data: null,
      });
    }
  },
  checking: async (ref) => {
    set({
      isloading: true,
      isFree: null,
    });

    try {
      const check = await find(`${CHECK_IS_FREE}?numeroTicket=${ref}`);
      setTimeout(() => {
        set({
          isloading: false,
          isFree: check.data,
        });
      }, 400);
    } catch (error) {
      set({
        isloading: false,
        isFree: "error",
      });
    }
  },
  reset: () => {
    set({
      isloading: false,
      isFree: null,
    });
  },
}));
